exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login {\n  width: 100%;\n  height: 100%;\n}\n.login-con {\n  margin: 0 auto;\n  padding-top: 200px;\n  width: 630px;\n}\n.login-con-header {\n  font-size: 16px;\n  font-weight: 300;\n  text-align: center;\n  padding: 30px 0;\n}\n.login-con .form-con {\n  padding: 10px 0 0;\n  height: 200px;\n}\n.login-con .login-tip {\n  font-size: 10px;\n  text-align: center;\n  color: #c3c3c3;\n}\n", ""]);

// exports
